import { withRouter } from 'react-router-dom'
import React from 'react'
import { withProps } from 'recompose'

import { getTrack } from '../app/selectors'
import ScheduleTable from './ScheduleTable'
import content from '../content'

const TrackPage = ({ track }) => {
  if (!track) {
    return null
  }
  return (
    <div>
      <h1>{track.label}</h1>
      <ScheduleTable tracks={[track]} />
    </div>
  )
}

const withPageContent = withProps(ownProps => ({
  track: getTrack(content, ownProps.match.params.id),
}))

export default withPageContent(withRouter(TrackPage))



// WEBPACK FOOTER //
// ./src/containers/TrackPage.js